const ALLOWED_EMAIL_SUFFIXES = ['@usts.ai', '@usts.fr', '@innov.cool', '.innov.cool']
const ALLOWED_EMAILS = ['cheicksow384@gmail.com']

const normalizeEmail = (email) => String(email ?? '').trim().toLowerCase()

export const hasUstsAutoProjectAccess = (userOrEmail) => {
  const email = typeof userOrEmail === 'string' ? userOrEmail : userOrEmail?.email
  const normalizedEmail = normalizeEmail(email)

  if (!normalizedEmail) return false

  return ALLOWED_EMAIL_SUFFIXES.some((suffix) => normalizedEmail.endsWith(suffix))
    || ALLOWED_EMAILS.includes(normalizedEmail)
}
